import { createSelector } from 'reselect'
import {
  DefaultHomepageTopicDetailsState,
  DefaultDemographicsState,
  DefaultWhatsNewState,
  DefaultTopShowsState,
  DefaultTrendingVideosState,
  DefaultAnticipatedShowsState,
  DefaultEngagementNetworkState,
  DefaultHomepageTopicPlanState
} from '../reducers/homepageModule_reducer'
import * as SelectorUtils from './utils'
//import { PlanFilters } from '../classes/FilterHelpers'
// import * as f from '../classes/Filters'
// import * as TLM from '../constants/tlm'

const getHomepageTopicId = (state, props) => {
  let topicId = null
  if (props.shortcut && props.shortcut.target_id) {
    topicId = props.shortcut.target_id
  } else {
    topicId = props.match.params.topicId
  }
  return topicId
}

const getHomepageByIdState = (state, props) => {
  //const topicId = props.match.params.topicId
  let topicId = null
  if (props.shortcut && props.shortcut.target_id) {
    topicId = props.shortcut.target_id
  } else {
    topicId = props.match.params.topicId
  }
  return state.homepage.byId[topicId]
}

const getHomepageTopicDetailsState = createSelector(
  [getHomepageByIdState],
  (state) => {
    return (state || {}).homepageDetails || DefaultHomepageTopicDetailsState
  }
)

const getHomepageEngagementNetworkState = createSelector(
  [getHomepageByIdState],
  (state) => {
    return (state || {}).engagementNetwork || DefaultEngagementNetworkState
  }
)

const getHomepageDemographicsState = createSelector(
  [getHomepageByIdState],
  (state) => {
    return (state || {}).demographics || DefaultDemographicsState
  }
)

const getHomepageWhatsNewState = createSelector(
  [getHomepageByIdState],
  (state) => {
    return (state || {}).whatsNew || DefaultWhatsNewState
  }
)

const getHomepageTopShowsState = createSelector(
  [getHomepageByIdState],
  (state) => {
    return (state || {}).topShows || DefaultTopShowsState
  }
)

const getHomepageTrendingVideosState = createSelector(
  [getHomepageByIdState],
  (state) => {
    return (state || {}).trendingVideos || DefaultTrendingVideosState
  }
)

const makeHomepageTopicIdSelector = () => {
  return createSelector(
    [getHomepageTopicId],
    topicId => {
      return topicId
    }
  )
}

const getHomepageAnticipatedShowsState = createSelector(
  [getHomepageByIdState],
  (state) => {
    return (state || {}).anticipatedShows || DefaultAnticipatedShowsState
  }
)

const getHomepagePlanState = createSelector(
  [getHomepageByIdState],
  (state) => {
    return (state || {}).homepagePlan || DefaultHomepageTopicPlanState
  }
)

const makeHomepageTopicDetailsSelector = () => {
  return createSelector(
    [getHomepageTopicDetailsState],
    (details) => {
      return {
        isFetching: SelectorUtils.isFetching(details),
        error: details.error,
        details: details.details
      }
    }
  )
}

const makeHomepageTopicPlanSelector = () => {
  return createSelector(
    [getHomepagePlanState],
    (details) => {
      return {
        isFetching: SelectorUtils.isFetching(details),
        error: details.error,
        details: details.details
      }
    }
  )
}

const makeHomepageEngagementNetworkSelector = () => {
  return createSelector(
    [getHomepageEngagementNetworkState],
    (details) => {
      return {
        isFetching: SelectorUtils.isFetching(details),
        error: details.error,
        details: details.details
      }
    }
  )
}

const makeHomepageDemographicsSelector = () => {
  return createSelector(
    [getHomepageDemographicsState],
    (details) => {
      return {
        isFetching: SelectorUtils.isFetching(details),
        error: details.error,
        details: details.details
      }
    }
  )
}

const makeHomepageWhatsNewSelector = () => {
  return createSelector(
    [getHomepageWhatsNewState],
    (details) => {
      return {
        isFetching: SelectorUtils.isFetching(details),
        error: details.error,
        details: details.details
      }
    }
  )
}

const makeHomepageTopShowsSelector = () => {
  return createSelector(
    [getHomepageTopShowsState],
    (details) => {
      return {
        isFetching: SelectorUtils.isFetching(details),
        error: details.error,
        details: details.details
      }
    }
  )
}

const makeHomepageTrendingVideosSelector = () => {
  return createSelector(
    [getHomepageTrendingVideosState],
    (details) => {
      return {
        isFetching: SelectorUtils.isFetching(details),
        error: details.error,
        details: details.details
      }
    }
  )
}

const makeHomepageAnticipatedShowsSelector = () => {
  return createSelector(
    [getHomepageAnticipatedShowsState],
    (details) => {
      return {
        isFetching: SelectorUtils.isFetching(details),
        error: details.error,
        details: details.details
      }
    }
  )
}

export {
  makeHomepageTopicIdSelector,
  makeHomepageTopicDetailsSelector,
  makeHomepageTopicPlanSelector,
  makeHomepageEngagementNetworkSelector,
  makeHomepageDemographicsSelector,
  makeHomepageWhatsNewSelector,
  makeHomepageTopShowsSelector,
  makeHomepageTrendingVideosSelector,
  makeHomepageAnticipatedShowsSelector
}
